import styled from "styled-components";

export const BtnUploadCerificateWidgetStyled = styled.div``;
